module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002sp.ebc02ce1.jpg";